// extracted by mini-css-extract-plugin
export default {"emailCaption":"EmailRegistrationForm--emailCaption--Ccjzm","submitButton":"EmailRegistrationForm--submitButton--4ptar"};